<template>
    <div class="logo">
        <router-link :to="url">
            <img class="logo1"  v-if="ishow == '1'" :src="darkLogo" alt="Corporate Logo"/>
            <img class="logo2" v-if="ishow == '2'" :src="darkLogo" alt="Corporate Logo"/>
        </router-link>
    </div>
</template>

<script>
    export default {
        name: 'Logo',
        props: {
            url: {
                type: String,
                default: '/'
            },
            lightLogo: {
                type: String,
                default: function () {
                    return require(`@/assets/images/logo/logo.png`)
                }
            },
            darkLogo: {
                type: String,
                default: function () {
                    return require(`@/assets/images/logo/logo-a.png`)
                }
            }
        },
		data(){
			return {
				ishow:'1',
			}
		},
		mounted(){
			this.toggleStickyHeader()
		},
		methods: {
		    toggleStickyHeader() {
		        const scrolled = document.documentElement.scrollTop;
		        if (scrolled > 100) {
					this.ishow = '2'
		        } else if (scrolled <= 100) {
					this.ishow = '1'
					if(this.$route.name != 'Home'){
						this.ishow = '2'
					}
		        }
		    }
		},
		created() {
		    window.addEventListener('scroll', this.toggleStickyHeader);
		},
    }
</script>
<style>
</style>